import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import Input from '../../components/input/input';
import ScrollArea from '../../components/scroll-area/scroll-area';
import Validation from '../../components/validation/validation';
import Select from '../../components/select/select';
import FlipSwitch from '../../components/flip-switch/flip-switch';
/* helpers */
import { httpRequest } from '../../utils/xml-request-helper';

class SchemesFormPage extends React.PureComponent {
    constructor(props) {
        super(props);
        const selectedSchemeType = props.model.types
            ? props.model.types.find(scheme => scheme.id === props.model.scheme.schemeType)
            : null;
        const protocolBindings = [
            { id: 0, name: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Artifact' },
            { id: 1, name: 'urn:oasis:names:tc:SAML:2.0:bindings:SOAP' },
            { id: 2, name: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect' },
            { id: 3, name: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST' }
        ];
        const selectedProtocolBinding = props.model.samlConfiguration && props.model.samlConfiguration.protocolBinding
            ? protocolBindings.find(pb => pb.name === props.model.samlConfiguration.protocolBinding)
            : null;

        this.state = {
            scheme: { ...props.model.scheme },
            oidcConfiguration: { ...props.model.oidcConfiguration },
            samlConfiguration: { ...props.model.samlConfiguration },
            protocolBindings,
            selectedProtocolBinding,
            selectedSchemeType
        };
    }

    setSchemeValue = (prop) => (value) => {
        this.setState({
            scheme: {
                ...this.state.scheme,
                [prop]: value
            }
        });
    };

    setOidcConfigurationValue = (prop) => (value) => {
        this.setState({
            oidcConfiguration: {
                ...this.state.oidcConfiguration,
                [prop]: value
            }
        });
    };

    setSamlConfigurationValue = (prop) => (value) => {
        this.setState({
            samlConfiguration: {
                ...this.state.samlConfiguration,
                [prop]: value
            }
        });
    };

    setSchemeType = selectedSchemeType => {
        this.setState({
            selectedSchemeType
        });
    };

    handleProtocolBindingChange = (selectedProtocolBinding) => {
        this.setState({
            selectedProtocolBinding,
            samlConfiguration: {
                ...this.state.samlConfiguration,
                protocolBinding: selectedProtocolBinding ? selectedProtocolBinding.name : ''
            }
        });
    };

    handleSubmit = (formElement, enableSubmit) => {
        const form = new FormData(formElement);
        form.append('Scheme.SchemeType', this.state.selectedSchemeType.id);
        if (this.state.selectedProtocolBinding) {
            form.append('SamlConfiguration.ProtocolBinding', this.state.selectedProtocolBinding.name);
        }
        const url = this.props.isEdit ? `/Schemes/Edit/${this.props.model.scheme.id}` : '/Schemes/Create';
        httpRequest({
            method: 'POST',
            url,
            token: this.props.token,
            onSuccess: () => { window.location.href = '/Schemes'; },
            onError: (res) => {
                const resObj = JSON.parse(res);
                Object.keys(resObj).forEach((key) => {
                    this.formRef.showError(key, () => resObj[key].join(';'));
                });
                enableSubmit();
            },
            body: form
        });
    };

    getSchemeForm = () => {
        if (this.state.selectedSchemeType.id === 1) {
            return (
                <React.Fragment>
                    <div className="form-row">
                        <div className="row">
                            <div className="col-12">
                                <label className="label">Authority</label>
                                <Validation.Wrapper validations={{ required: true, url: true }}>
                                    <Input
                                        name="OidcConfiguration.Authority"
                                        type="text"
                                        value={this.state.oidcConfiguration.authority}
                                        onChange={this.setOidcConfigurationValue('authority')}
                                        placeholder="Enter Authority"
                                    />
                                </Validation.Wrapper>
                            </div>
                            <div className="col-12">
                                <label className="label">Client Id</label>
                                <Validation.Wrapper validations={{ required: true }}>
                                    <Input
                                        name="OidcConfiguration.ClientId"
                                        type="text"
                                        value={this.state.oidcConfiguration.clientId}
                                        onChange={this.setOidcConfigurationValue('clientId')}
                                        placeholder="Enter Client Id"
                                    />
                                </Validation.Wrapper>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="row">
                            <div className="col-12">
                                <label className="label">Response Type</label>
                                <Validation.Wrapper validations={{ required: true }}>
                                    <Input
                                        name="OidcConfiguration.ResponseType"
                                        type="text"
                                        value={this.state.oidcConfiguration.responseType}
                                        onChange={this.setOidcConfigurationValue('responseType')}
                                        placeholder="Enter Response Type"
                                    />
                                </Validation.Wrapper>
                            </div>
                            <div className="col-12">
                                <label className="label">Remote Sign Out Path</label>
                                <Validation.Wrapper validations={{ required: true, url: { require_host: false } }}>
                                    <Input
                                        name="OidcConfiguration.RemoteSignOutPath"
                                        type="text"
                                        value={this.state.oidcConfiguration.remoteSignOutPath}
                                        onChange={this.setOidcConfigurationValue('remoteSignOutPath')}
                                        placeholder="Enter Remote Sign Out Path"
                                    />
                                </Validation.Wrapper>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <div className="form-row">
                    <div className="row">
                        <div className="col-12">
                            <label className="label">Entity Id</label>
                            <Validation.Wrapper validations={{ required: true }}>
                                <Input
                                    name="SamlConfiguration.EntityId"
                                    type="text"
                                    value={this.state.samlConfiguration.entityId}
                                    onChange={this.setSamlConfigurationValue('entityId')}
                                    placeholder="Enter Entity Id"
                                />
                            </Validation.Wrapper>
                        </div>
                        <div className="col-12">
                            <label className="label">Single Sign On Service</label>
                            <Validation.Wrapper validations={{ required: true, url: { require_tld: false } }}>
                                <Input
                                    name="SamlConfiguration.SingleSignOnService"
                                    type="text"
                                    value={this.state.samlConfiguration.singleSignOnService}
                                    onChange={this.setSamlConfigurationValue('singleSignOnService')}
                                    placeholder="Enter Single Sign On Service"
                                />
                            </Validation.Wrapper>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="row">
                        <div className="col-24">
                            <label className="label">Protocol Binding</label>
                            <Validation.Wrapper validations={{ required: true }}>
                                <Select
                                    name="SamlConfiguration.ProtocolBinding"
                                    placeholder="Select Protocol Binding"
                                    value={this.state.selectedProtocolBinding}
                                    onChange={this.handleProtocolBindingChange}
                                    options={this.state.protocolBindings}
                                    valueKey="id"
                                    labelKey="name"
                                />
                            </Validation.Wrapper>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="flex-row flex-center">
                        <div className="flex-grow">
                            <label className="label">Force Auth</label>
                        </div>
                        <div className="flex-shrink">
                            <FlipSwitch
                                name="SamlConfiguration.ForceAuth"
                                isActive={this.state.samlConfiguration.forceAuth}
                                onChange={this.setSamlConfigurationValue('forceAuth')}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="flex-row flex-center">
                        <div className="flex-grow">
                            <label className="label">Is Passive</label>
                        </div>
                        <div className="flex-shrink">
                            <FlipSwitch
                                name="SamlConfiguration.IsPassive"
                                isActive={this.state.samlConfiguration.isPassive}
                                onChange={this.setSamlConfigurationValue('isPassive')}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    saveFormRef = (ref) => { this.formRef = ref; };

    render() {
        return (
            <div className="sten-content sten-schemes-form-page">
                <div className="sten-content__header flex-row">
                    <div className="flex-shrink">
                        <a rel="prev" className="btn-link icon" href="/schemes" title="Back to schemes list">
                            <span className="icon icon-arrow-left" />
                        </a>
                    </div>
                    <div className="flex-grow">
                        <h1 className="sten-content__title text-uppercase">
                            {`${this.props.isEdit ? 'Edit' : 'Create'} Authentication Scheme`}
                        </h1>
                    </div>
                </div>
                <ScrollArea className="sten-content__body">
                    <Validation.Form
                        method="post"
                        name="SchemesForm"
                        onSubmit={this.handleSubmit}
                        clearErrorsOnSubmit
                        ref={this.saveFormRef}
                    >
                        <div className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-16 col-xs-24">
                                    <div className="form-row">
                                        <FlipSwitch
                                            name="Scheme.Enabled"
                                            activeLabel="Enabled"
                                            inactiveLabel="Disabled"
                                            isActive={this.state.scheme.enabled}
                                            onChange={this.setSchemeValue('enabled')}
                                        />
                                    </div>
                                    <div className="row form-row">
                                        <div className="col-12">
                                            <label className="label">Display Name</label>
                                            <Validation.Wrapper validations={{ required: true }}>
                                                <Input
                                                    name="Scheme.DisplayName"
                                                    type="text"
                                                    value={this.state.scheme.displayName}
                                                    onChange={this.setSchemeValue('displayName')}
                                                    placeholder="Enter Scheme Name"
                                                />
                                            </Validation.Wrapper>
                                        </div>
                                        <div className="col-12">
                                            <label className="label">Scheme Type</label>
                                            {this.props.isEdit ? (
                                                <Input
                                                    disabled
                                                    name="Scheme.SchemeTypeDescription"
                                                    type="text"
                                                    value={this.state.scheme.schemeTypeDescription}
                                                />
                                            )
                                                : (
                                                    <Select
                                                        name="Scheme.SchemeType"
                                                        valueKey="id"
                                                        labelKey="name"
                                                        options={this.props.model.types}
                                                        value={this.state.selectedSchemeType}
                                                        placeholder="Please select Scheme type"
                                                        onChange={this.setSchemeType}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sten-content__section-header text-uppercase">
                            <h4>
                                {this.state.selectedSchemeType.id === 1 ? 'Oidc Configuration' : 'Saml Configuration'}
                            </h4>
                        </div>
                        <div className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-16 col-xs-24">
                                    {this.getSchemeForm()}
                                </div>
                            </div>
                        </div>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-16 col-xs-24">
                                    <Validation.Button className="btn btn--primary col-24">
                                        {this.props.isEdit ? 'Save Changes' : 'Create New Scheme' }
                                    </Validation.Button>
                                </div>
                            </div>
                        </section>
                        <input type="hidden" name="__RequestVerificationToken" value={this.props.token} />
                    </Validation.Form>
                </ScrollArea>
            </div>
        );
    }
}

SchemesFormPage.defaultProps = {
    isEdit: false
};

SchemesFormPage.propTypes = {
    isEdit: PropTypes.bool,
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default SchemesFormPage;
